module.exports = __webpack_public_path__ + "img/logo.1adc34a7.png";